/**版本购买 */
export default [
    {
        name:'verbuy',
        path:'verbuy',
        meta: { title: '版本购买' },
        component: ()=>import('@/pages/verbuy/index.vue')
    }
]